import { useState } from 'react';
import PropTypes from 'prop-types';
import BrandMark from '../../../Components/SVG/BrandMark';
import AccountMenu from '../../../Components/AccountMenu/AccountMenu';
import { API_CONFIG } from '../../../../config/api';
import { reduxPage } from '../../../Core/store'
import { MAIN_CONFIG } from '../../../../config/main';
import './donor-header.scss';
import { handleKeyDown } from '../../../Utility/ApplicationFormUtility';
import Close from '../../../Components/SVG/Close';
import HamburgerIcon from '../../../Components/SVG/HamburgerIcon';


const DonorHeader = ({ data, currentUser, currentPath, setAccountSwitcherVisible, notifications, activeHeaderNav, userContext, pageType, setRoleSwitcherVisible, herokuRole, setModalState = () => { }, pageData }) => {
    const { USER_CONTEXT, PAGE_TYPES } = MAIN_CONFIG;
    const { branding, currentAccount, availableAccounts, user, token } = data;
    const selectedClass = 'CTAWhite active-current-page';
    const [showChatBox, setShowChatBox] = useState(false);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    const toggleMobileMenu = () => {
     setMobileMenuOpen(prev => !prev);
    };

    const getNavData = () => {
    if (userContext === USER_CONTEXT.DONOR || userContext === USER_CONTEXT.SUPERDONOR) {
        return {
        navString: branding ? branding.primary_tabs__c : 'Overview',
        menuMap: API_CONFIG.NAV_MENU_MAP.DONOR,
        };
        }
    }

    const reorderItems = (item) => {
      const desiredOrder = [
        "Overview",
        "Programs",
        "Applications",
        "Connect",
        "Reports",
        "Disbursements",
        "Donations",
        "Contacts",
        "Admin",
      ];
      
      // Create a new array with elements sorted according to the desired order
      const sortedItems = item?.sort(
        (a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b)
      );
      return sortedItems;
    };

    /**
     * Renders the navigation based on the user context.
     * The API returns a semi-colon separated string with the nav
     * items, the mapping is hard-coded for now.
     * @returns {object[]}
     */
    const renderNavigation = () => {
        if (pageType === PAGE_TYPES.DONOR.NEW_SCHOLARSHIP) {
            return [<li key='main-nav-item-0' className='H6DesktopWhite'>New&nbsp;Award Program</li>]
        }

        if (pageType === PAGE_TYPES.DONOR.EDIT_SCHOLARSHIP) {
            return [<li key='main-nav-item-0' className='H6DesktopWhite'>Edit&nbsp;Award Program</li>]
        }
        if (pageType === PAGE_TYPES.DONOR.PREVIEW_SCHOLARSHIP) {
            return null
        }
        const navData = getNavData();
        const navLabels = navData.navString.split(';');
        let reorderNavLabels = reorderItems(navLabels)
        return reorderNavLabels.map((navLabel, index) => {
            let urlArg = navData.menuMap.find(item => item.apiLabel === navLabel)
            let url = '/'
            if (urlArg) {
                url = urlArg.url
            }
            const isActive = navLabel.toLowerCase() === activeHeaderNav.toLowerCase();
            if(navLabel === 'Connect' && currentAccount?.elements_communication_tab__c){
                url = MAIN_CONFIG.ELEMENTS_URLS.DONOR.CONNECT(currentAccount.sfid)
            }
            if(navLabel === "Reports") {
                url = MAIN_CONFIG.ELEMENTS_URLS.DONOR.REPORT_DASHBOARD(currentAccount.sfid)
            }
            if(navLabel === "Contacts") {
                url = MAIN_CONFIG.ELEMENTS_URLS.DONOR.CONTACT(currentAccount.sfid)
            }
            const handleMenuUrlClick = () => {
                window.location.href = url
                sessionStorage.removeItem('isBackButtonClick');
            }


            return (
                <li tabIndex={0} onKeyDown={(e)=>handleKeyDown(e,handleMenuUrlClick)} key={`main-nav-item-${index}`} className={`CTAWhite ${isActive ? selectedClass : ''} ${navLabel === 'Overview' && 'Dashboard'}`} onClick={handleMenuUrlClick}>
                    {navLabel === 'Overview' ? "Dashboard" : navLabel}
                </li>
            )
        });
    }
    /**
     * Render the action section of the header.
     * @returns {JSX.Element}
     */
    const renderActions = () => {
        return (
            <>
                <AccountMenu
                    currentAccount={currentAccount}
                    availableAccounts={availableAccounts}
                    setAccountSwitcherVisible={setAccountSwitcherVisible}
                    setRoleSwitcherVisible={setRoleSwitcherVisible}
                    userContext={userContext}
                    setShowChatBox={setShowChatBox}
                    user={user}
                    herokuRole={herokuRole}
                    pageData = {pageData}
                />
            </>
        )

    }

    return (
      <header id="donor-header__inner">
        <div id="donor-header__left">
            <BrandMark
              id="donor-header__brand-mark"
              ariaLabel="Kaleidoscope Logo"
              ariaLabelDescription=""
            />

          <button
            className="hamburger-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            {isMobileMenuOpen ? <Close color={MAIN_CONFIG.COLORS.fillWhite} /> : <HamburgerIcon /> }
          </button>

          {/* Dropdown Nav */}
          {isMobileMenuOpen && (
            <div className="mobile-dropdown-menu">
              <ul className="mobile-nav-list">{renderNavigation()}</ul>
            </div>
          )}

          <nav
            aria-label="Header Top Navigation"
            aria-labelledby="Header Top Navigation"
            role=""
            className="header__menu-wrapper"
            id='donor-header__menu-wrapper'
          >
            <ul className="header__menu">{renderNavigation()}</ul>
          </nav>
        </div>
        <div id="donor-header__right">{renderActions()}</div>
      </header>
    );
}

// handle PropTypes
DonorHeader.propTypes = {
    data: PropTypes.object,
    currentUser: PropTypes.object,
    currentPath: PropTypes.string,
    setAccountSwitcherVisible: PropTypes.func,
    notifications: PropTypes.array,
    activeHeaderNav: PropTypes.string,
    userContext: PropTypes.string,
    pageType: PropTypes.string,
    setRoleSwitcherVisible: PropTypes.func,
    herokuRole: PropTypes.string,
    setModalState: PropTypes.func,
    pageData: PropTypes.object
};
export default reduxPage(DonorHeader)